import { AlertService } from '../../shared/services/alert.service';
import { OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { Assessment } from "../../shared/models/assessment";
import { SaveMessages } from "../../shared/models/save-messages";
import { AssessmentService } from "../../shared/services/assessment.service";
import { AssessmentHydrator } from '../../shared/services/assessment-hydrator.service';
import { AssessmentCompressorService } from 'app/shared/services/assessment-compressor.service';
var AssessmentEditComponent = /** @class */ (function () {
    function AssessmentEditComponent(_assessmentService, assessmentCompressor, router, alertService, hydrator, route) {
        this._assessmentService = _assessmentService;
        this.assessmentCompressor = assessmentCompressor;
        this.router = router;
        this.alertService = alertService;
        this.hydrator = hydrator;
        this.route = route;
        this.hasLoadedAssessment = false;
        this._messages = new SaveMessages();
        this._assessment = new Assessment();
    }
    AssessmentEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        var uid = this.route.snapshot.params['uid'];
        var version = this.route.snapshot.queryParams['version'];
        this._assessmentService.uid = uid;
        var assessmentPromise;
        if (version) {
            assessmentPromise = this._assessmentService.getAssessmentVersion(uid, version);
        }
        else {
            assessmentPromise = this._assessmentService.getAssessment(uid);
        }
        assessmentPromise.then(function (assessment) {
            if (assessment) {
                // if we have nothing back in the admin then we are going to create our own
                _this.assessment = assessment;
                _this.hasLoadedAssessment = true;
            }
            else {
                // TODO: stephen handle 404 errors
                //this._$state.go("404");
                _this.router.navigate(["page-not-found"]);
            }
        }, function (error) {
            _this.hasLoadedAssessment = true;
            // TODO: stephen can't all of this just go in the catch block below?
            console.error(error);
            _this.alertService.error("Failed to retrieve assessment data from server");
            _this.assessment = new Assessment();
            _this.assessment.uid = _this._assessmentService.uid;
        })
            .catch(function (error) {
            this.hasLoadedAssessment = true;
            this.alertService.error("Failed to retrieve assessment data from server");
            console.error(error);
        });
    };
    Object.defineProperty(AssessmentEditComponent.prototype, "assessment", {
        get: function () {
            return this._assessment;
        },
        set: function (v) {
            this._assessment = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssessmentEditComponent.prototype, "messages", {
        get: function () {
            return this._messages;
        },
        enumerable: true,
        configurable: true
    });
    AssessmentEditComponent.prototype.getRawAssessment = function () {
        return JSON.stringify(this.assessmentCompressor.compress(this.assessment), null, " ");
    };
    AssessmentEditComponent.prototype.save = function () {
        var _this = this;
        console.log(this._assessment);
        this._assessmentService.saveAssessment(this._assessment)
            .then(function () {
            _this.alertService.success("Assessment Saved!");
        }).catch(function () {
            _this.alertService.error("Error occurred in saving your assessment. Please try again.");
        });
    };
    AssessmentEditComponent.prototype.updateAssessmentContents = function () {
        var reportContents = this.reportContents.nativeElement;
        var jsonData = reportContents.value;
        var assessmentJSON;
        try {
            assessmentJSON = JSON.parse(jsonData);
            this.assessment = this.hydrator.hydrate(assessmentJSON);
            this.alertService.info("Assessment contents updated.  Make sure to save the assessment before proceeding");
        }
        catch (error) {
            this.alertService.error("The assessment contains invalid JSON and could not be parsed");
            console.error(error);
        }
    };
    AssessmentEditComponent.prototype.moveUpScale = function (scale) {
        this.assessment.shiftScaleUp(scale);
    };
    AssessmentEditComponent.prototype.moveDownScale = function (scale) {
        this.assessment.shiftScaleDown(scale);
    };
    AssessmentEditComponent.prototype.moveUpSet = function (questionSet) {
        this.assessment.shiftQuestionSetUp(questionSet);
        this.save();
    };
    AssessmentEditComponent.prototype.moveDownSet = function (questionSet) {
        this.assessment.shiftQuestionSetDown(questionSet);
        this.save();
    };
    AssessmentEditComponent.prototype.deleteQuestionSet = function (questionSet) {
        var _this = this;
        if (!confirm("Are you sure you want to delete this question set?")) {
            return;
        }
        this.assessment.removeQuestionSet(questionSet);
        this._assessmentService.saveAssessment(this.assessment).then(function () {
        })
            .catch(function (error) {
            console.error(error);
            _this.alertService.error("An error occurred in removing the question set.");
        });
    };
    AssessmentEditComponent.prototype.deleteScale = function (scale) {
        var _this = this;
        if (!confirm("Are you sure you want to delete this scale?")) {
            return;
        }
        scale.isDeleted = true;
        this.assessment.removeScale(scale);
        this._assessmentService.saveAssessment(this.assessment).then(function () {
            _this.alertService.success("Scale deleted...");
            // we don't do anything here...
        }, function () {
            // TODO: stephen handle the error
            _this.alertService.error("Error occurred.  Could not delete this scale");
            scale.isDeleted = false;
            _this.assessment.addScale(scale);
        });
    };
    return AssessmentEditComponent;
}());
export { AssessmentEditComponent };



// WEBPACK FOOTER //
// ./src/app/admin/assessment-edit/assessment-edit.component.ts.pre-build-optimizer.js